import { css, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { EkoElement } from "@/utilities/element";

@customElement("eko-menu-toggle")
class MenuToggle extends EkoElement {
  static styles = [
    ...EkoElement.styles,
    css`
      eko-button {
        --eko-button-inline-size: 32px;
      }
    `,
  ];

  @property({ reflect: true, type: Boolean }) toggled: boolean = false;

  private handleClick() {
    this.toggled = !this.toggled;
    this.dispatchEvent(new CustomEvent("shell:menu:toggle", { bubbles: true }));
  }

  render() {
    return html`<eko-button aria-label="Toggle menu" @click=${this.handleClick} square>
      <eko-icon name=${this.toggled ? "minus" : "menu-01"}></eko-icon>
    </eko-button>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-menu-toggle": MenuToggle;
  }
}

export default MenuToggle;
